import React from "react";
import { Flex } from "@chakra-ui/react";
import { FaFileAlt } from "react-icons/fa";
import { ROUTES } from "constants/routes-path";
import CardList from "components/Card/CardList";

function TransportList() {
    const transportsConfig = [
        {
            icon: FaFileAlt,
            route: `${ROUTES.panel}${ROUTES.transportManagement}${ROUTES.permittee}`,
            titleKey: "permittees.title",
            descriptionKey: "permittees.description",
        }
    ];

    return (
        <Flex
            gap="5"
            direction="column"
            pt={{ base: "180px", sm: "155px", lg: "90px" }}
            px="30px"
        >
            <CardList items={transportsConfig} />
        </Flex>
    );
}

export default TransportList;